import {
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  useMutation,
  useQuery,
} from '@tanstack/react-query';
import { CreditNoteSettingsAPI } from 'api/credit-note-settings';
import {
  CreditNoteConfiguration,
  CreditNoteReason,
  CreditNoteReasonPayload,
} from 'components/organisms/credit-notes-settings/types';
import { GENERAL_API_STALE } from 'config/query-config';

export const CREDIT_NOTE_SETTINGS_QUERY_KEY = [
  'credit-note-essential-settings',
];
export const CREDIT_NOTE_REASONS_QUERY_KEY = ['credit-note-reasons'];

export const useCreditNoteEssentialSettingsQuery = (
  queryOptions: UseQueryOptions<
    CreditNoteConfiguration,
    unknown,
    CreditNoteConfiguration,
    typeof CREDIT_NOTE_SETTINGS_QUERY_KEY
  > = {},
): UseQueryResult<CreditNoteConfiguration> =>
  useQuery(
    CREDIT_NOTE_SETTINGS_QUERY_KEY,
    () => CreditNoteSettingsAPI.getSettingsConfiguration(),
    {
      staleTime: GENERAL_API_STALE,
      ...queryOptions,
    },
  );

export const useUpdateCreditNoteEssentialSettingMutation =
  (): UseMutationResult<CreditNoteConfiguration, unknown, any> => {
    return useMutation(({ payload }) =>
      CreditNoteSettingsAPI.updateSettingsConfiguration(payload),
    );
  };

export const useGetCreditNoteReasonsQuery = (
  queryOptions: UseQueryOptions<
    CreditNoteReason[],
    unknown,
    CreditNoteReason[],
    typeof CREDIT_NOTE_REASONS_QUERY_KEY
  > = {},
): UseQueryResult<CreditNoteReason[]> =>
  useQuery(
    CREDIT_NOTE_REASONS_QUERY_KEY,
    () => CreditNoteSettingsAPI.getCreditNoteReasons(),
    {
      staleTime: GENERAL_API_STALE,
      ...queryOptions,
    },
  );

export const useCreateCreditNoteReasonMutation = (): UseMutationResult<
  CreditNoteReason,
  unknown,
  CreditNoteReasonPayload
> => {
  return useMutation((payload: CreditNoteReasonPayload) =>
    CreditNoteSettingsAPI.createCreditNoteReason(payload),
  );
};

export const useUpdateCreditNoteReasonMutation = (): UseMutationResult<
  CreditNoteReason,
  unknown,
  { reasonId: number; payload: Partial<CreditNoteReasonPayload> }
> => {
  return useMutation(
    ({
      reasonId,
      payload,
    }: {
      reasonId: number;
      payload: Partial<CreditNoteReasonPayload>;
    }) => CreditNoteSettingsAPI.updateCreditNoteReason(reasonId, payload),
  );
};

export const useDeleteCreditNoteReasonMutation = (): UseMutationResult<
  void,
  unknown,
  number
> => {
  return useMutation((reasonId: number) =>
    CreditNoteSettingsAPI.deleteCreditNoteReason(reasonId),
  );
};
